<template>
  <div class="col-sm-12 mb-3 mb-md-0 w6">
    <div class="card">
      <div class="card-body" v-if="services.length > 0 && customer">
        <div class="row">
          <div class="col-xl-3 dropdown_men">
            <div class="aside_mpan">
              <ul class="services_gas list-unstyled">
                <li
                  v-for="(service, index) in services"
                  :key="index"
                  :class="{ activeService: service === activeService }"
                  class="meter-info-tab-hover"
                  @click="changeActive(service)"
                >
                  <a>
                    <img
                      v-if="service.Service.ServiceType === 'Gas'"
                      src="@/assets/img/gas_icon.png"
                      class="img-fluid"
                      alt="Gas icon"
                    />
                    <img
                      v-else-if="service.Service.ServiceType === 'Electricity'"
                      src="@/assets/img/electricity_icon.png"
                      class="img-fluid"
                      alt="Gas icon"
                    />
                    <span class="d-block spt ml-5">{{
                      service.Service.ServiceIdentifier
                    }}</span>
                    <span class="d-block ml-5">{{
                      service.Site.Address.AddressLines[0]
                    }}</span>
                  </a>
                  <hr class="mb-0" />
                </li>
              </ul>
            </div>
          </div>
          <!-- col 3 close -->
          <!-- MPAN WIDGET START -->
          <div class="col-xl-9" v-if="activeService">
            <nav>
              <div
                class="nav nav-tabs nav-fill"
                id="nav-tabs-meter-info"
                role="tablist"
              >
                <a
                  class="nav-item nav-link text-sm-left active"
                  id="meter_point_summary-tab"
                  data-toggle="tab"
                  href="#nav-meter_point_summary"
                  role="tab"
                  aria-controls="nav-meter_point_summary"
                  aria-selected="true"
                  >Meter Point Summary</a
                >
                <template>
                  <a
                    v-if="showAdvancesTab"
                    class="nav-item nav-link text-sm-left"
                    id="nav-advances-tab"
                    data-toggle="tab"
                    href="#nav-advances"
                    role="tab"
                    aria-controls="nav-advances"
                    aria-selected="false"
                  >
                    {{ advancesTabLabel }}
                  </a>
                   <a
                    v-if="showReadingsTab"
                    class="nav-item nav-link text-sm-left"
                    id="nav-readings-tab"
                    data-toggle="tab"
                    href="#nav-readings"
                    role="tab"
                    aria-controls="nav-readings"
                    aria-selected="false"
                  >
                    {{ readingsTabLabel }}
                  </a>
                </template>
                <a
                  class="nav-item nav-link text-sm-left"
                  id="nav-meters-tab"
                  data-toggle="tab"
                  href="#nav-meters"
                  role="tab"
                  aria-controls="nav-meters"
                  aria-selected="false"
                  >Meters</a
                >
                <a
                  class="nav-item nav-link text-sm-left"
                  id="nav-registration-tab"
                  data-toggle="tab"
                  href="#nav-registration"
                  role="tab"
                  aria-controls="nav-registration"
                  aria-selected="false"
                  >Registration</a
                >
              </div>
            </nav>
            <!-- Tab content -->
            <!-- Meter Point Summary Start -->
            <div class="tab-content py-2 px-2 px-sm-0">
              <meter-point-summary></meter-point-summary>
              <readings></readings>
              <div
                class="tab-pane fade"
                id="nav-advances"
                role="tabpanel"
                aria-labelledby="nav-advances-tab"
              >
                <electricity-advances></electricity-advances>
              </div>
              <meters></meters>
              <registration></registration>
            </div>
            <!-- main. row close -->
          </div>
          <!-- card body close -->
        </div>
        <!-- card close -->
      </div>
      <!-- main col  close -->
    </div>
    <!-- main row  close -->
  </div>
</template>

<script>
import MeterPointSummary from './meterInfoTabs/meterPointSummary/MeterPointSummary';
import Readings from './meterInfoTabs/readings/Readings.vue';
import Meters from './meterInfoTabs/meters/Meters.vue';
import Registration from './meterInfoTabs/Registration.vue';
import ElectricityAdvances from './meterInfoTabs/readings/components/ElectricityReadingsHH.vue';

export default {
	components: {
		MeterPointSummary,
		Readings,
		Meters,
		Registration,
		ElectricityAdvances,
	},
	methods: {
		changeActive(service) {
			this.$store.dispatch('changeActiveService', service);
		},
	},

	watch: {
		services() {
			this.$store.dispatch('changeActiveService', this.services[0]);
		},
	},

	computed: {
		// contract() {
		//   return this.$store.state.contracts.contract;
		// },
		customer() {
			return this.$store.state.customers.customer;
		},
		services() {
			let services = this.$store.state.contracts.services
				? [...this.$store.state.contracts.services]
				: [];
			services = services.sort((serviceA, serviceB) => {
				const statusA = serviceA.Contract.ContractStatus === 'Chargeable' ? 0 : 1;
				const statusB = serviceB.Contract.ContractStatus === 'Chargeable' ? 0 : 1;
				if (statusA !== statusB) return statusA - statusB;
				if (serviceA.Contract.StartDate < serviceB.Contract.StartDate) return 1;
				else if (serviceA.Contract.StartDate > serviceB.Contract.StartDate)
					return -1;
				else if (serviceA.Contract.Created > serviceB.Contract.Created)
					return -1;
				else return 1;
			});
			return this.$_.uniq(
				services,
				false,
				this.$_.iteratee((service) => service.Service.ServiceIdentifier)
			);
		},
		activeService() {
			return this.$store.state.meters.activeService;
		},
		activeServiceType() {
			return this.$store.getters.activeServiceType;
		},
		measurementMethod() {
			return this.$store.getters.measurementMethod;
		},
		showReadingsTab() {
			return this.$store.getters.showReadingsTab;
		},
		showAdvancesTab() {
			return this.$store.getters.showAdvancesTab;
		},
		isCurrentlyHH() {
			return this.$store.getters.isCurrentlyHH;
		},
		hasHistoricReadings() {
			return this.$store.getters.hasHistoricReadings;
		},
		hasHistoricAdvances() {
			return this.$store.getters.hasHistoricAdvances;
		},
		readingsTabLabel() {
			return this.$store.getters.readingsTabLabel;
		},
		advancesTabLabel() {
			return this.$store.getters.advancesTabLabel;
		},
	},
};
</script>
